import React from 'react';
import './InfoBlock.css';

const InfoBlock = () => (
    <section className="heroSection">
        <article className="infoBlock">
            <h3>Blogs</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate eaque, explicabo vitae cumque quae cum illo adipisci fugit ea porro ullam voluptatem facilis sapiente debitis esse facere alias eligendi atque.
            Earum sapiente, sit recusandae laboriosam possimus totam praesentium quis accusantium nemo unde reprehenderit reiciendis itaque nesciunt. Voluptate sapiente unde, eos pariatur magnam voluptas eum optio reprehenderit facere, molestiae sunt voluptates!
            Alias molestiae dolorum eum optio perferendis sunt, sapiente blanditiis delectus vitae quae animi, voluptates doloremque quo autem excepturi inventore iure officia natus voluptatem! Debitis laborum temporibus ab laboriosam impedit veniam.</p>
        </article>
        <article className="moreInfo">Natus quibusdam doloremque rem voluptates?
            <button className="moreBtn">More</button>
        </article>
    </section>
);

export default InfoBlock;